<template>
    <el-dialog title="选择充值方案" :visible.sync="innerVisible" class="dialog-table" width="800px" :before-close="closeDialogTable">
        <div>
            <el-form :inline="true" ref="formInline" :model="formInline" size="small" class="demo-form-inline" @submit.native.prevent>
                <el-form-item label="方案名称:" prop="planName">
                    <el-input v-model="formInline.planName" placeholder="请输入方案名称" clearable @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="tableTh">
            <el-table :data="tableData.result" ref="singleTable2" border  highlight-current-row
                      @current-change="handleCurrentChangeTable" row-key="id" style="width: 100%;" class="tableStyle table-radio">
                <el-table-column align="center" width="55" label>
                    <template slot-scope="scope">
                        <!--<el-radio @change.native="handleCurrentChangeTable(scope.row)" v-model="selected" :label="scope.row.id">&nbsp;</el-radio>-->
                        <el-checkbox @change.native="handleCurrentChangeTable(scope.row)" v-model="selected" :label="scope.row.id"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column label="方案名称" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.planName }}
                    </template>
                </el-table-column>
                <el-table-column label="充值方案（首充）">
                    <template slot-scope="scope">
                        <p v-for="(item,index) in scope.row.firstRecharge" :key="index">
                            <!-- <span>充值类型：{{item.durationType==1?'月度会员':item.durationType==2?'年度会员':item.durationType==3?'普通会员':item.durationType==4?'季度会员':'充值金币'}}；</span> -->
                            <span v-if="item.rechargeType == 0">充值类型：充值金币；</span>
                            <span v-if="item.rechargeType == 1">
                                充值类型：{{item.durationType==1?'月度会员':item.durationType==4?'季度会员':item.durationType==2?'年度会员':''}}；
                            </span>
                            <span v-if="item.rechargeType == 3">充值类型：单剧购买；</span>
                            <span>实付金额：{{item.money}}；</span>
                            <span>金币数量：{{item.rechargeType==0?item.money * 100:0}}；</span>
                            <span>充值说明：{{item.rechargeInfo}}；</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="充值方案（复充）">
                    <template slot-scope="scope">
                        <p v-for="(item,index) in scope.row.againRecharge" :key="index">
                            <!-- <span>充值类型：{{item.durationType==1?'月度会员':item.durationType==2?'年度会员':item.durationType==3?'普通会员':item.durationType==4?'季度会员':'充值金币'}}；</span> -->
                            <span v-if="item.rechargeType == 0">充值类型：充值金币；</span>
                            <span v-if="item.rechargeType == 1">
                                充值类型：{{item.durationType==1?'月度会员':item.durationType==4?'季度会员':item.durationType==2?'年度会员':''}}；
                            </span>
                            <span v-if="item.rechargeType == 3">充值类型：单剧购买；</span>
                            <span>实付金额：{{item.money}}；</span>
                            <span>金币数量：{{item.rechargeType==0?item.money * 100:0}}；</span>
                            <span>充值说明：{{item.rechargeInfo}}；</span>
                        </p>
                    </template>
                </el-table-column>
            </el-table>
            <div class="foot-table" style="text-align:center;">
                <el-pagination
                        @current-change="handleCurrentChange"
                        @size-change="handleSizeChange"
                        :page-sizes="[5, 20, 50, 100, 200, 500]"
                        :page-size="tableData.pageSize"
                        background
                        :current-page="currentPage"
                        layout="sizes, prev, pager, next, jumper, ->, total"
                        :total="tableData.totalNum">
                </el-pagination>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialogTable">取 消</el-button>
            <el-button type="primary" @click="tableSureBtn">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import {waylist} from "@/api/wb/app/recharge";
export default {
    name: 'RechargeTable',
    props:['visible', 'selectReturn', 'postbackId','appId','rechargeId'],
    data() {
        return {
            innerVisible: this.visible,
            selected: [],
            formInline: {
                planName: '',
                // type: ''
            },
            typeOptions: [
                {
                    value: 1,
                    label: '免费回传'
                }
            ],
            tableData: [],
            currentPage: 1,
            pageSize: 5,
            currentRow: ''
        }
    },
    watch: {
        visible(newValue) {
            this.innerVisible = newValue;
            this.$nextTick(()=>{
                this.$refs.singleTable2.setCurrentRow(this.selectReturn)
                // if (this.postbackId) {
                //     console.log(this.postbackId)
                //     const row = this.tableData.result.find(row => row.id === this.postbackId);
                //     this.$refs.singleTable.setCurrentRow(row);
                // } else {
                //     this.$refs.singleTable.setCurrentRow(this.selectReturn)
                // }
            })
        },
        innerVisible(newValue) {
            this.$emit('update:visible', newValue);
        }
    },
    mounted() {
        this.getTableData()
    },
    methods: {
        search () {
            this.currentPage = 1
            this.getTableData()
        },
        resetQuery: function(){
            this.$refs['formInline'].resetFields()
            this.getTableData()
        },
        // 分页
        handleCurrentChange (value) {
            this.currentPage = value
            this.getTableData()
        },
        // pageSize切换
        handleSizeChange (val) {
            this.pageSize = val
            this.currentPage = 1
            this.getTableData()
        },
        // 单选
        handleCurrentChangeTable(val) {
            this.$refs.singleTable2.setCurrentRow(val);
            this.currentRow = val
            this.selected = [val?.id]
            console.log(this.selected)
        },
        // 确定按钮
        tableSureBtn() {
            this.$emit('rechargeSure', this.currentRow);
            this.$emit('cancelDialogRecharge', false);
            // this.closeDialogTable()
            // this.$refs.singleTable.setCurrentRow();
        },
        // 关闭弹框
        closeDialogTable () {
            console.log('关闭弹框')
            this.$emit('cancelDialogRecharge', false);
            // this.$refs.singleTable.setCurrentRow();
            // this.selected = []
        },
        getTableData() {
            let json2 = {
                appId: this.appId,
                pageNo: this.currentPage,
                pageSize: this.pageSize
            };
            let json1 = this.formInline;
            let paramJson = { ...json1, ...json2 };
            waylist(paramJson).then(response => {
                if (response.data.head.flag === 0) {
                    this.tableData = response.data.content
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
    }
}
</script>
